import React, { useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    return (
        <div className="min-h-screen bg-neutral-50 text-slate-900 font-sans selection:bg-primary selection:text-white">
            <Sidebar open={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className={`${sidebarOpen ? 'lg:ml-64' : 'lg:ml-20'} ml-0 flex flex-col min-h-screen transition-all duration-300 ease-in-out`}>
                <Navbar />
                <main className="flex-1 p-4 pt-24 lg:pt-8 sm:p-6 lg:p-8 pb-10 mt-2">
                    <div className="max-w-7xl mx-auto w-full animate-fade-in">
                      {children}
                    </div>
                </main>
            </div>
        </div>
    );
}

export default Layout;
